// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 501 ? "bc98253f" : chunkId) + "." + {"501":"136269598e1dd79a","2931":"334743beb05fb485","4199":"ec136a08d44302d2","6793":"f57464ca23fa9330"}[chunkId] + ".js";
};